export const fmtMinutes = (m) => {
  if (m === null || m === undefined) return "—";
  const h = Math.floor(m / 60);
  const r = m % 60;
  return `${h} h ${String(r).padStart(2, "0")}`;
};

const TZ = "America/Montreal";

export const fmtClock = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-CA", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: TZ }) : "—");

export const fmtDateTimeMtl = (iso) => new Date(iso).toLocaleString("fr-CA", { dateStyle: "medium", timeStyle: "short", timeZone: TZ });

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const s = new Date(iso).toLocaleString("sv-SE", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false });
  return s.replace(" ", "T").slice(0, 16);
};

// Naive "YYYY-MM-DDTHH:mm" is interpreted by the backend as Montréal time.
export const fromLocalInput = (v) => v || null;

export const getPosition = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("unsupported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      (e) => reject(e),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
    );
  });
